<template>
    <div class="selectable-table client-selection">
        <div class="user-import-upload__messages">
            <alert type="warning" v-if="jobsRunning">
                {{ trans('user-import.upload.jobs-running') }}
            </alert>
        </div>
        <div class="client-selection-search">
            <div class="client-selection-search__description">
                {{trans('user-import.please_select_client')}}
            </div>
            <div class="client-selection-search__searchbar">
                <search-bar
                    :placeholder="'vuetables.search.placeholder.client'">
                </search-bar>
            </div>
        </div>

        <v-server-table :url="route('tenantapi.clients.index-selection')" :columns="columns" :options="tableOptions" ref="table">
            <label class="radio-button" slot="radio" slot-scope="props" >
                <input type="radio"
                    name="client"
                    :checked="selectedClient.id == props.row.id"
                >
                <span class="radio-button__checkmark"></span>
            </label>

            <div slot="cls" slot-scope="props">
                <colored-letter-square
                    :name="props.row.name"
                    :length="2"
                >
                </colored-letter-square>
            </div>

        </v-server-table>

        <input type="hidden" name="client_id" :value="selectedClient.id" hidden/>
    </div>
</template>

<script>
    import { EventBus } from '../eventbus.js';
    import { Event } from 'vue-tables-2';
    import userImportClient from './partials/UserImportClient';

    export default {

        props: {
            jobsRunning: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                columns: [ 'radio', 'cls', 'name'],
                tableOptions: {
                    headings: {
                        radio: '   ',
                        cls: '   ',
                        name: this.trans('clients.label.name'),
                    },

                    orderBy: {
                        column: 'name',
                        ascending: true
                    },

                    texts: {
                        count: this.trans('vuetables.label.countText'),
                        filter: this.trans('vuetables.label.filter'),
                        noResults: this.trans('vuetables.label.noResults'),
                        loading: Vue.prototype.trans('vuetables.label.loading'),
                        filterPlaceholder: this.trans('vuetables.label.search')
                    },

                    templates: {
                        name: userImportClient,
                    },

                    sortable: ['name'],
                 },
                selectedClient: {}
            }
        },

        created() {
            Event.$on('vue-tables.row-click', (e) => {
                this.selectedClient = e.row;
                this.$emit('change', this.selectedClient);
            });

            var filter = this.debounce((query) => {
                this.$refs.table.setFilter(query);
            }, 500);

            EventBus.$on('onFilter', query => {
                filter(query);
            });
        },

    }
</script>
